import type { FolderNode, DiagramSummary } from '../../domains/dashboard/models'
import { isSystemArchivedContainer } from './archivedFolder'

export const canWriteToFolder = (folder: FolderNode): boolean => {
  if (folder.accessKind === 'context-only') return false
  // pathOnly nodes are view-only (no write actions)
  if (folder.pathOnly) return false
  // For legacy folders, check permissions properly
  if (folder.readOnly) return false
  const role = folder.role ?? folder.effectivePermissionRole
  if (!role) return false
  return role === 'owner' || role === 'editor' || role === 'moderator'
}

/**
 * Whether the context menu should be enabled for a folder item.
 * Policy for dashboard context menu (legacy-specific):
 * - Native: allow (no granular data yet)
 * - Legacy: block if readOnly; allow only for owner or editor
 */
export const canOpenContextForFolder = (folder: FolderNode): boolean => {
  if (isSystemArchivedContainer(folder)) return false
  if (folder.accessKind === 'context-only') return false
  // pathOnly nodes are view-only (no actions)
  if (folder.pathOnly) return false
  if (folder.source === 'native') return true
  if (folder.readOnly) return false
  const role = folder.role ?? folder.effectivePermissionRole
  return role === 'owner' || role === 'editor'
}

/**
 * Whether the context menu should be enabled for a diagram item.
 * Policy for dashboard context menu (legacy-specific):
 * - Native: allow (no granular data yet)
 * - Legacy: block if parent folder is readOnly; allow only for owner or editor
 */
export const canOpenContextForDiagram = (diagram: DiagramSummary, parentFolder: FolderNode): boolean => {
  if (parentFolder.accessKind === 'context-only') return false
  if (diagram.source === 'native') return true
  if (parentFolder.readOnly) return false
  const role = diagram.role
  return role === 'owner' || role === 'editor'
}
